import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmPaymentOptionKind } from "@natiwi/shared/models/payment-option-kind.model";

export class NatPaymentOptionKindRepository extends NatCatalogRepository<OrmPaymentOptionKind> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/PaymentOptionKinds';
        let repoModel: Type<OrmPaymentOptionKind> = OrmPaymentOptionKind;
        this.init(repoUrl, repoModel);
    }
}